import React from 'react';
import { useMutation, useApolloClient } from '@apollo/client';
import clearDailyDietPlanCacheObjects from '../../../Apollo/clearDailyDietPlanCacheObjects';
import clearTrackerCacheObjects from '../../../Apollo/clearTrackerCacheObjects';

interface IDietGenerateConnectorApolloProps {
  children: ({
    generateDiet,
  }: {
    generateDiet: (variables: any) => Promise<any>;
  }) => React.ReactElement;
  mutation: any;
  post?: (data: any) => void;
}

const DietGenerateConnectorApollo: React.FC<IDietGenerateConnectorApolloProps> = ({
  children,
  mutation,
  post,
}) => {
  const client = useApolloClient();
  const [generate] = useMutation(mutation);

  const generateDiet = async (variables: any) => {
    const response = await generate({
      variables: { ...variables },
    });

    clearDailyDietPlanCacheObjects(client);
    clearTrackerCacheObjects(client);

    // broadcast channel
    if (post) {
      post('reload');
    }

    return response.data.me.dietGenerate;
  };
  return children({ generateDiet });
};

export default DietGenerateConnectorApollo;
